import { XCircle } from 'lucide-react';
import {
  PageHeader, DashboardCard, StatusBadge,
  Table, TableHeader, TableRow, TableHead, TableBody, TableCell,
} from '@zafroi/ui-kit';
import { useReminders, useReminderTransition } from '@/hooks/useCommercial';
import { QueryStateGuard } from '@/components/common/QueryStateGuard';
import { reminderStatusVariants } from '@/config/commercial-status';
import { shortDate } from '@/lib/format';

const cap = (s: string) => s.charAt(0) + s.slice(1).toLowerCase().replace(/_/g, ' ');

export function RemindersPage() {
  const q = useReminders();
  const transition = useReminderTransition();
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Setup" title="Reminders" description="Scheduled dunning nudges across the receivables ladder." />
      <DashboardCard flushBody>
        <QueryStateGuard data={q.data} isLoading={q.isLoading} isError={q.isError} emptyTitle="No reminders scheduled">
          {(data) => (
            <Table>
              <TableHeader><TableRow>
                <TableHead>Scheduled</TableHead><TableHead>Channel</TableHead><TableHead className="text-right">Step</TableHead>
                <TableHead>Status</TableHead><TableHead className="text-right">Action</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {data.map((x) => (
                  <TableRow key={x.id}>
                    <TableCell className="text-muted-foreground">{shortDate(x.scheduledFor)}</TableCell>
                    <TableCell>{cap(x.channel)}</TableCell>
                    <TableCell className="text-right tabular-nums">{x.sequenceStep}</TableCell>
                    <TableCell><StatusBadge status={x.status} variants={reminderStatusVariants} /></TableCell>
                    <TableCell className="text-right">
                      {x.status === 'SCHEDULED' && (
                        <button
                          onClick={() => transition.mutate({ id: x.id, to: 'CANCELLED' })}
                          className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11.5px] text-muted-foreground hover:bg-muted"
                        >
                          <XCircle className="h-3.5 w-3.5" /> Cancel
                        </button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </QueryStateGuard>
      </DashboardCard>
    </div>
  );
}
